import { Components, Theme } from '@mui/material'

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  defaultProps: {
    // TODO - remove the elevation variant once all usage is removed
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.default,
      backgroundColor: theme.palette.bg.surface.elevated,
      // MUI paints a dark-mode elevation overlay via --Paper-overlay,
      // which would tint the surface token on elevation Papers
      backgroundImage: 'none',
    }),
    outlined: ({ theme }) => ({
      borderWidth: theme.strokeWidth.default,
      borderStyle: 'solid',
      borderColor: theme.palette.border.subtle,
    }),
    rounded: ({ theme }) => ({
      borderRadius: theme.shape['radius-md'],
      '--paper-border-radius': theme.shape['radius-md'],
    }),
  },
  variants: [
    {
      props: { variant: 'interactive' },
      style: ({ theme }) => ({
        borderWidth: theme.strokeWidth.default,
        borderStyle: 'solid',
        borderColor: theme.palette.border.subtle,
        cursor: 'pointer',
        // Matches EntityRow, so a surface and a row that both open something lift the same way.
        '&:hover': {
          borderColor: theme.palette.border.strong,
          boxShadow: theme.customShadows.xs,
        },
        '&:focus-visible': {
          outline: `${theme.strokeWidth.strongest} solid ${theme.palette.border.focus}`,
          outlineOffset: `-${theme.strokeWidth.strongest}`,
        },
      }),
    },
  ],
}
